import * as React from "react";
import {
  Box,
  Center,
  ChakraProvider,
  Link,
  Spinner,
  Stack,
  useToast,
  Text,
} from "@chakra-ui/react";
import { Redirect, Router } from "@reach/router";
import { Login } from "./pages/login";
import { Register } from "./pages/register";
import { EmailSignUp } from "./pages/emailSignUp";
import { CreateGroup } from "./pages/createGroup";
import { MyGroups } from "./pages/myGroups";
import { ForgotPassword } from "./pages/forgotPasswors";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase";
import { Dashboard } from "./pages/dashboard";
import { PlatformProvider } from "./components/PlatformContext";
import firebase from "firebase/app";
import {
  ERROR_TOAST_DURATION,
  REFERRAL_CODE_EXPIRY_MS,
  REFERRAL_SEARCH_PARAM,
  SUPPORT_WA_LINK,
} from "./common";
import { theme } from "./common/theme";
import { UserProvider } from "./components/UserContext";
import { GroupDetailsAuth } from "./pages/groupDetailsAuth";
import { GroupDetailsAnon } from "./pages/groupDetailsAnon";
import { Settings } from "./pages/settings";
import { Home } from "./pages/home";
import { TermsAndConditions } from "./pages/termsAndConditions";
import { Referrals } from "./pages/referrals";
import { ReferralTracker } from "./components/referrals/ReferralTrackerContext";
import { Button } from "./components/Button";
import UnderMaintenanceLogo from "./assets/femaleConstructionWorker.png";

const IS_UNDER_MAINTENANCE = true;

export const App = () => {
  const [user, loading, error] = useAuthState(auth) as [
    firebase.User | undefined,
    boolean,
    any
  ];

  const toast = useToast();
  React.useEffect(() => {
    if (error) {
      toast({
        title: "Oops some error occurred!",
        description: "Please reload",
        status: "error",
        duration: ERROR_TOAST_DURATION,
        isClosable: true,
      });
    }
  }, [error, toast]);

  console.log("App.tsx", { user, loading, error });

  if (IS_UNDER_MAINTENANCE) {
    return (
      <ChakraProvider theme={theme}>
        <UnderMaintenance />
      </ChakraProvider>
    );
  }

  return (
    <ChakraProvider theme={theme}>
      <ReferralTracker
        expiryInMS={REFERRAL_CODE_EXPIRY_MS}
        searchParam={REFERRAL_SEARCH_PARAM}
      >
        <PlatformProvider>
          {loading ? (
            <Center h="100vh" w="100vw">
              <Spinner thickness="4px" size="xl" color="#0078FF" />
            </Center>
          ) : user ? (
            <UserProvider firebaseUser={user}>
              <Router>
                {/* <Home path="/" isAuthenticated={true} /> */}
                <CreateGroup path="/create-group" />
                <MyGroups path="/my-groups" />
                <Dashboard path="/dashboard" isAuthenticated={true} />
                <Settings path="/settings" />
                <GroupDetailsAuth path="/group/:groupId" />
                <TermsAndConditions
                  path="/terms-and-conditions"
                  isAuthenticated={true}
                />
                <Referrals path="/referrals" />
                <Redirect noThrow from="*" to="/dashboard" />
              </Router>
            </UserProvider>
          ) : (
            <Router>
              <Home path="/" isAuthenticated={false} />
              <Login path="/login" />
              <Register path="/register" />
              <ForgotPassword path="/forgot-password" />
              <EmailSignUp path="/email-signup" />
              <GroupDetailsAnon path="/group/:groupId" />
              <TermsAndConditions
                path="/terms-and-conditions"
                isAuthenticated={false}
              />
              <Dashboard path="/dashboard" isAuthenticated={false} />
              <Redirect noThrow from="*" to="/" />
            </Router>
          )}
        </PlatformProvider>
      </ReferralTracker>
    </ChakraProvider>
  );
};

const UnderMaintenance = () => {
  return (
    <Stack height="100vh" width="100vw" align="center" justify="center">
      <Stack direction="column" align="center" justify="center" spacing="14">
        <Box as="img" src={UnderMaintenanceLogo} />
        <Text textStyle="mainTitle">Estamos actualizando la pagina</Text>

        <Link href={SUPPORT_WA_LINK} target="_blank">
          <Button variant="pulpo">Contactanos</Button>
        </Link>
      </Stack>
      <Stack
        position="absolute"
        bottom="20px"
        left="0px"
        right="0px"
        direction="row"
        align="center"
        justify="center"
      >
        <Box
          as="img"
          src="https://res.cloudinary.com/pulpo-club/image/upload/c_scale,f_auto,w_200/v1625166150/PulpoLogo/logo_apqcsv.png"
        />
      </Stack>
    </Stack>
  );
};
